// Shared non-portal staff department/designation taxonomy.
// Single source of truth so StaffManagement, StaffAttendance, StaffLeaves and
// StaffSalary always offer the same designation list.

export const DEPARTMENTS = ['General','Medical','Sports','Security','Admin','Other'];

export const DEPT_DESIGNATIONS = {
  General:  ['Peon','Cleaner','Driver','Cook','Gardener','Sweeper','Helper','Other'],
  Medical:  ['School Doctor','Nurse','Psychologist','Dentist','First Aid Staff','Other'],
  Sports:   ['Sports Coach','PT Teacher','Fitness Trainer','Swimming Coach','Other'],
  Security: ['Security Guard','Gatekeeper','Warden','Other'],
  Admin:    ['Receptionist','Office Boy','Librarian','Lab Assistant','IT Staff','Other'],
  Other:    ['Other'],
};

export const DEPT_COLORS = {
  General:'#f59e0b', Medical:'#ef4444', Sports:'#10c98e',
  Security:'#6b7194', Admin:'#3b6ef8', Other:'#9094a8',
};

export const ALL_DESIGNATIONS = [...new Set(Object.values(DEPT_DESIGNATIONS).flat())];

export const NON_PORTAL_COLORS = ['#f59e0b','#06b6d4','#ef4444','#84cc16','#9094a8','#10c98e','#8b5cf6','#3b6ef8'];
